import { useState } from 'react';

/**
 * The `gh repo delete` guard: an override only unlocks once the user has typed
 * the exact name of the thing being overridden. Matching mirrors the server
 * (trimmed, case-sensitive), so a value that unlocks the button is also one
 * the API accepts as `confirmWorkflowName`.
 */
export function typedNameMatches(typed: string, name: string): boolean {
  return name.trim().length > 0 && typed.trim() === name.trim();
}

export function useTypedNameConfirm(name: string) {
  const [typed, setTyped] = useState('');
  return {
    typed,
    setTyped,
    matches: typedNameMatches(typed, name),
    reset: () => setTyped(''),
  };
}
